












































































import { Vue, Component, Prop } from "vue-property-decorator"

@Component
export default class SCustomerShop extends Vue {
    @Prop({ default: "" }) private street!: string
    @Prop({ default: "" }) private cityZipCode!: string
    @Prop({ default: 0 }) private numberOfBleBoxes!: number
    @Prop({ default: 0 }) private numberOfUpdateRequiredBleBoxes!: number
    @Prop({ default: 0 }) private numberOfActiveBleBoxes!: number
    @Prop({ default: 0 }) private numberOfOfflineBleBoxes!: number

    private onClick() {
        this.$emit("click")
    }
}
